const separators = /[-._/\s]+/g;
const ATTRIBUTE_NAME = "data-refname";

// THIS IS FOR QA AUTOMATION, DO NOT CHANGE NAMES WITHOUT INFORMING QA TEAM
const getNameProp = (...names) => {
  return {
    [ATTRIBUTE_NAME]: names.join(" ").trim().toLowerCase().replace(separators, "-")
  };
};

export default getNameProp;
